export const GET_QUOTE_HEADING = "Find Perfect Venues for Your Wedding"
export const GET_QUOTE_SUBHEADING = "Search and Discover banquet halls, wedding lawns and corporate party halls to your exact budget and requirements"
export const DISCOVER_AND_BOOK ="Discover and Book From The best"
export const CORPORATE_EVENT_VENUE_HEADING ="Find Perfect Venue for Your Corporate Event"
export const CORPORATE_EVENT_VENUE_SUBHEADING ="Simplified Venue Booking and Event Planning For All Your Corporate Event Needs"
export const GET_STARTED_TEXT ="Get Started in Just 3 Steps"

export const discoverandbook = [
    {icon:"vm_quote_review", heading: "Checkout Reviews and Stories", desc: "Shortlist & connect with those who match your requirements" },
    {icon:"vm_quote_call", heading: "Direct Connection", desc: "Get no-hindrance direct connect with the Venue Manager" },
    {icon:"vm_quote_manage",heading: "Guaranteed Service Quality", desc: "A dedicated Customer Support to help you with your search" }, 
];


export const Corporatesteps = [
    {heading: "Share Your Corporate Event Requirements", desc: "Give us a break-down of your exact event requirements with your contact details. Our Event Expert will get in touch with you promptly." },
    {heading: "Dedicated Event Expert", desc: "Each query is handled by a dedicated Event Expert. All your event problems are now ours." },
    {heading: "Online Quotes and Booking", desc: "Experts will send you quotes and rates. Help with recce for your event venue and vendor requirements. All bookings are online and fully transparent." }, 
];

export const CORPORATE_OFFERING_SEGMENT_TITLE = "Our Service Offerings";

export const Corporatecontent = [
    {
        heading: "Comfort At Click Of Button",
        subheading: "Browse through all vendors and venues online",
        icon: "vm_corporate_click_icon",
        content: [
            { corporatetext: "Trim down the search as per requirements from 100+ to few venues/vendors" },
            { corporatetext: "Have all quotes and prices online" },
            { corporatetext: "Achieve transparency with team and stakeholders for all discussions involved" }
        ]
    },
    {
        heading: "Dedicated Support",
        subheading: "An Event Expert For All Your Queries",
        icon: "vm_corporate_agent_icon",
        content: [
            { corporatetext: "Our experts bring real-live experience to tackle on-ground challenges." },
            { corporatetext: "Help with recce and visits to venues." },
            { corporatetext: "Help with rate negotiation and price discovery." }
        ]
    },
    {
        heading: "Central Booking",
        subheading: "Direct One Point of Contact for All Expenses and Invoicing",
        icon: "vm_corporate_calendar_icon",
        content: [
            { corporatetext: "Discover all vendors and event requirements under one roof" },
            { corporatetext: "All bookings and payments flow through one point of contact." },
            { corporatetext: "Get proper detailed and itemized GST Billing for each service booked." }
        ]
    }
];
